import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, inject } from '@angular/core';

@Component({
	selector: 'pk-broker-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class LoaderComponent implements OnChanges {
	private cdr = inject(ChangeDetectorRef);

	@Input() show = false;
	@Input() color = 'black';
	@Input() text: string;
	@Input() display = 'flex';
	@Input() extraClasses = '';
	@Input() textAlign = 'text-center';

	ngOnChanges(): void {
		this.cdr.markForCheck();
	}
}
